import * as React from 'react';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiPaper-root': {
        borderRadius: theme.spacing(2),
    },
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),

    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),

    },
}));

export default function CustomDialog({
    open,
    onClose,
    title,
    children,
    actions,
    showCloseIcon = true,
    maxWidth = 'md'
}) {
    return (
        <BootstrapDialog
            fullWidth
            onClose={onClose}
            aria-labelledby="customized-dialog-title"
            open={open}
            maxWidth={maxWidth}
        >
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                {title}
            </DialogTitle>

            {showCloseIcon && (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <CloseIcon />
                </IconButton>
            )}

            <DialogContent dividers>{children}</DialogContent>

            {actions && <DialogActions>{actions}</DialogActions>}
        </BootstrapDialog>
    );
}
